/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BarrierFreeApartmentEnum = 1 | 2 | 3;

export const BarrierFreeApartmentEnum = {
    NUMBER_1: 1 as BarrierFreeApartmentEnum,
    NUMBER_2: 2 as BarrierFreeApartmentEnum,
    NUMBER_3: 3 as BarrierFreeApartmentEnum
};

